import React, { Component } from 'react';
import styled from 'styled-components';

import { PageGrid } from '../shared/CommonStyledComponents';
import { clientData } from '../data';
import NextPageLink from '../shared/NextPageLink';

import selectedClientBg from '../assets/images/selected_client_bg.svg';
import forDevelopersSideLink from '../assets/images/sideLinks/for_developers_side_link.svg';


const OurClientsContainer = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 64em) {
    flex-direction: column;
  }
`;

const SelectedClientContainer = styled.div`
  display: flex;
  align-items: center;
  height: 59vh;

  @media (max-width: 64em) {
    flex-direction: column;
    height: 100%;
  }
`;

const SelectedClientBgImage = styled.img`
  position: absolute;
  height: 100%;
  z-index: -10;

  @media (max-width: 64em) {
    height: auto;
    width: 100%;
  }
`;

const SelecteClientImage = styled.img`
  padding: 3px;
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid;
  margin-left: 2vw;
  opacity: 1;
  width: 8vw;
  -webkit-transition: opacity 0.4s;
  transition: opacity 0.4s;

  @media (max-width: 64em) {
    margin-top: 9vh;
    margin-bottom: 8vh;
    width: 37vw;
  }
`;

const SelectedClientContent = styled.div`
  display: flex;
  -webkit-transition: opacity 0.4s;
  transition: opacity 0.4s;

  @media (max-width: 64em) {
    flex-direction: column;
  }
`;

const SelectedClientDetails = styled.div`
  min-width: 24vw;
  margin-left: 2vw;
  align-items: center;
  display: flex;
  padding-right: 15px;

  @media (max-width: 64em) {
    padding-right: 0;
    margin-left: 0;
  }
`;

const SelectedClientDetailsInner = styled.div`
  @media (max-width: 64em) {
    width: 100%;
  }
`;

const SelectedClientName = styled.h2`
  font-weight: 300;
  font-size: 2vw;
  border-bottom: 1px solid;
  display: inline-block;
  margin-bottom: 12px;
  margin-top: 0;

  @media (max-width: 64em) {
    font-size: 6.5vw;
    text-align: center;
    margin: auto;
    display: table;
    padding-bottom: 5px;
    margin-bottom: 5px;
  }
`;

const SelectedClientTitle = styled.span`
  font-size: 1vw;
  font-weight: 400;
  display: block;

  @media (max-width: 64em) {
    font-size: 3.8vw;
    text-align: center;
  }
`;

const SelectedClientTestimonial = styled.div`
  width: 35vw;
  font-size: 1vw;
  border-left: 1px solid;
  padding-left: 2vw;

  @media (max-width: 64em) {
    border: none;
    margin-top: 7px;
    text-align: center;
    width: auto;
    margin-left: 0;
    padding-left: 0;
    font-size: 3vw;
  }
`;

const AllClientsList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 2vw;

  img{
    width: 2.2vw;
    margin-bottom: 0.6vw;
    margin-top: 0.6vw;
    cursor: pointer;
    background-color: #FFC400;
    border-radius: 50%;
    padding: 2px;
    -webkit-transition: transform 0.4s;
    transition: transform 0.4s;
    transform: scale(1);

     &:hover{
       transform: scale(1.8);
     }
  }

  @media (max-width: 64em) {
    flex-direction: row;
    margin-top: 5vw;
    display: flex;
    flex-wrap: wrap;

    img{
      width: 6.2vw;
    }
  }
`;

const ClientListItem = styled.button`
  background-color: transparent;
  border: none;
  outline: none;

  @media (max-width: 64em) {
    flex-grow: 1;
  }
`;


class OurClients extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedClientId: 1
    };

    this.selectClient = this.selectClient.bind(this);
  }

  selectClient(id) {
    const selectedClientImg = document.getElementById('selected-client-img');
    const selectedClientDetails = document.getElementById('selected-client-details');

    selectedClientImg.classList.add('updating');
    selectedClientDetails.classList.add('updating');

    setTimeout(() => {
      this.setState({
        selectedClientId: id
      });

      selectedClientImg.classList.remove('updating');
      selectedClientDetails.classList.remove('updating');
    }, 400);
  }

  render() {
    const { selectedClientId } = this.state;

    const selectedClient = clientData.find(client => client.id === selectedClientId);


    return (
      <PageGrid id="clients">
        <OurClientsContainer>
          <SelectedClientContainer>
            <SelectedClientBgImage src={selectedClientBg} alt="Selected client bg" />
            <SelecteClientImage
              id="selected-client-img"
              src={selectedClient.image}
              alt="Selected client"
            />
            <SelectedClientContent id="selected-client-details">
              <SelectedClientDetails>
                <SelectedClientDetailsInner>
                  <SelectedClientName>{selectedClient.name}</SelectedClientName>
                  <SelectedClientTitle>{selectedClient.title}</SelectedClientTitle>
                </SelectedClientDetailsInner>
              </SelectedClientDetails>
              <SelectedClientTestimonial>
                {selectedClient.testimonial.map((testimonial, index) =>
                // eslint-disable-next-line react/no-array-index-key
                  <p key={index}>{testimonial}</p>)}
              </SelectedClientTestimonial>
            </SelectedClientContent>
          </SelectedClientContainer>
          <AllClientsList>
            {clientData.map(client => (
              <ClientListItem key={client.id} onClick={() => { this.selectClient(client.id); }}>
                <img src={client.image} alt="Client" />
              </ClientListItem>
            ))}
          </AllClientsList>
        </OurClientsContainer>

        <NextPageLink
          color="FFC400"
          image={forDevelopersSideLink}
          text="FOR DEVELOPERS"
        />
      </PageGrid>
    );
  }
}


export default OurClients;



// WEBPACK FOOTER //
// ./src/components/OurClients.js